export const LABELS = {
  TITLE: ['components.filter.dropdown.title', 'Filters'],
  TITLE_ACTIVE: ['components.filter.dropdown.titleActive', 'Filters ({{count}})'],
  CLEAR: ['components.filter.dropdown.clear', 'Clear'],
  SAVE: ['components.filter.dropdown.save', 'Done'],
};
